var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16 3.414l-9.293 9.293c-.39.39-1.024.39-1.414 0-.39-.39-.39-1.024 0-1.414L14.586 2H12c-.552 0-1-.448-1-1s.448-1 1-1h5c.552 0 1 .448 1 1v5c0 .552-.448 1-1 1s-1-.448-1-1V3.414zM16 10c0-.552.448-1 1-1s1 .448 1 1v6.002C18 17.107 17.106 18 16 18H2c-1.105 0-2-.893-2-2V2C0 .896.894 0 1.998 0H8c.552 0 1 .448 1 1s-.448 1-1 1H2v14h14v-6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.e5112b8e2e451abeda9ff9c02a32613b.svg";
export { ForwardRef as ReactComponent };